export default "__VITE_ASSET__hXkV3Hwl__"